import { gql } from '@apollo/client';

export const GET_PRICING_FEE_ITEM_PAGE = gql`
  query GetPricingFeeItemPage($filters: PricingFeeItemFilterInput, $pageRequest: PageRequestTypeInput) {
    getPricingFeeItemPage(filters: $filters, pageRequest: $pageRequest) {
      content {
        id
        businessFeeCode
        businessFeeName
        businessScenarioCode
        businessCode
        description
      }
      page
      size
      totalElements
      totalPages
      hasNext
      hasPrevious
    }
  }
`;

export const CREATE_PRICING_FEE_ITEM = gql`
  mutation CreatePricingFeeItem($input: CreatePricingFeeItemInput!) {
    createPricingFeeItem(input: $input)
  }
`;

export const UPDATE_PRICING_FEE_ITEM = gql`
  mutation UpdatePricingFeeItem($input: UpdatePricingFeeItemInput!) {
    updatePricingFeeItem(input: $input)
  }
`;

export const DELETE_PRICING_FEE_ITEM = gql`
  mutation DeletePricingFeeItem($id: Long!) {
    deletePricingFeeItem(id: $id)
  }
`;
